const SIMULATION_OPTIONS = 'simulation_options',
  PCB_EXTRACTION_OPTIONS = 'pcb_extraction_options', PKG_EXTRACTION_OPTIONS = 'pkg_extraction_options',
  PCB_PORT_CONFIGURATION = 'pcb_port_configuration', PKG_PORT_CONFIGURATION = 'pkg_port_configuration',
  SOC_PACKAGE_MODEL = 'soc_package_model', SOC_BUFFER_MODEL = 'soc_buffer_model',
  DRAM_PACKAGE_MODEL = 'dram_package_model',
  DRAM_BUFFER_MODEL = 'dram_buffer_model',
  DRAM_STANDBY_MODEL = 'dram_stand_by_model',
  POWER_COMP_MODEL = 'power_comp_model';
const COMPONENT_SETUP_LIST = [SOC_PACKAGE_MODEL, SOC_BUFFER_MODEL, DRAM_PACKAGE_MODEL, DRAM_BUFFER_MODEL, DRAM_STANDBY_MODEL, POWER_COMP_MODEL]
const ALL_APPLY_LIST = [SIMULATION_OPTIONS, PCB_EXTRACTION_OPTIONS, PKG_EXTRACTION_OPTIONS, PCB_PORT_CONFIGURATION, PKG_PORT_CONFIGURATION,
  SOC_PACKAGE_MODEL, SOC_BUFFER_MODEL,
  DRAM_PACKAGE_MODEL, DRAM_BUFFER_MODEL, DRAM_STANDBY_MODEL,
  POWER_COMP_MODEL]

const BUFFER_MODEL_LIST = [SOC_BUFFER_MODEL, DRAM_BUFFER_MODEL, DRAM_STANDBY_MODEL], SOC_SETUP = [SOC_PACKAGE_MODEL, SOC_BUFFER_MODEL]
const DRAM_SETUP = [DRAM_PACKAGE_MODEL, DRAM_BUFFER_MODEL, DRAM_STANDBY_MODEL]

export {
  SIMULATION_OPTIONS, PCB_EXTRACTION_OPTIONS, PKG_EXTRACTION_OPTIONS,
  PCB_PORT_CONFIGURATION, PKG_PORT_CONFIGURATION,
  SOC_PACKAGE_MODEL, SOC_BUFFER_MODEL,
  DRAM_PACKAGE_MODEL, DRAM_BUFFER_MODEL, DRAM_STANDBY_MODEL,
  POWER_COMP_MODEL, COMPONENT_SETUP_LIST,
  BUFFER_MODEL_LIST, SOC_SETUP, DRAM_SETUP
}
function getSettingTreeData(isPkg, isPort, isMultiRank) {
  const treeData = [
    {
      title: 'Settings',
      key: 'settings',
      children: [
        {
          title: 'Simulation Options',
          key: SIMULATION_OPTIONS,
        },
        {
          title: 'Modeling Options',
          key: 'modeling_options',
          children: [
            {
              title: 'PCB Extraction',
              key: PCB_EXTRACTION_OPTIONS,
            },
            isPkg && {
              title: 'Package Extraction',
              key: PKG_EXTRACTION_OPTIONS,
            },
            isPort && {
              title: 'PCB Port Configuration',
              key: PCB_PORT_CONFIGURATION,
            },
            isPkg && {
              title: 'Package Port Configuration',
              key: PKG_PORT_CONFIGURATION,
            },
          ].filter(item => !!item),
        },
        {
          title: 'SoC Setup',
          key: 'setup',
          children: [
            {
              title: 'Package Model',
              key: SOC_PACKAGE_MODEL,
            },
            {
              title: "Buffers",
              key: SOC_BUFFER_MODEL,
            },
          ],
        },
        {
          title: 'DRAM Setup',
          key: 'dram_setup',
          children: [
            {
              title: 'Package Model',
              key: DRAM_PACKAGE_MODEL,
            },
            {
              title: "Buffers",
              key: DRAM_BUFFER_MODEL,
            },
            isMultiRank && {
              title: 'Stand-by Buffer',
              key: DRAM_STANDBY_MODEL,
            },
          ].filter(item => !!item),
        },
        {
          title: 'Power Component',
          key: POWER_COMP_MODEL,
        },
      ].filter(item => !!item),
    },
  ]
  return treeData
}

export {
  getSettingTreeData,
}